import Lead from 'app/models/lead';
import BaseModal from 'app/views/modals/base_modal';

import { showSuccess, showError } from 'utils/messages';

import tmpl from 'templates/lead_gather_modal';

export default BaseModal.extend({
  compiledTemplate: tmpl,

  events: {
    'click .cancel': 'close',
    'submit #lead-form': 'submit',
  },

  initialize(options) {
    this.model = new Lead({});
    this.source = options.source;
  },

  submit(e) {
    if (e) { e.preventDefault(); }

    const self = this;
    const email = this.$('input#lead-email').val();
    if (email) {
      this.model.save({ source: this.source, email }, {
        success: () => {
          this.close();
          showSuccess('Your inquiry has been submitted to EasyPost! You will be contacted shortly.');
        },

        error() {
          self.close();
          showError('Unfortunately the browser was unable to communicate with the EasyPost servers, please mail support@easypost.com to get in touch!');
        },
      });
    }
  },
});



// WEBPACK FOOTER //
// ./app/views/modals/lead_gather_modal.js